import { closeBrackets } from '@codemirror/autocomplete';
import type { Extension } from '@codemirror/state';

import {
  usedValidatorMap,
  usedErrors,
  pastingMode,
} from '../editor-state-configs/editor-config.js';
import { filterFieldLanguageExtension } from '../parser/filterfield-language.js';

export const FilterFieldLanguageExtension: Extension = (() => [
  /**
   * Filter field language + syntax highlighting.
   *
   * Error highlighting is also done with the highlight extensions, since using an actual
   * linter, potential errors only show up after a short (configurable) delay. As soon as
   * you type something again, the errors disappear and then show up again if the input is
   * still invalid. Using the decoration plugins, we can immediately show errors.
   * The actual linter extension is only used to show tooltips with proper error messages.
   */
  // The extension for parsing the filter field language into a syntax tree.
  filterFieldLanguageExtension,
  // Automatically close brackets.
  closeBrackets(),
  usedValidatorMap,
  usedErrors,
  pastingMode,
])();
